import { useContext } from "react";
import { Field } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import { useIntl } from "react-intl";
import Section from "../../../common/section";
import * as Validations from "../../../common/form/validator";
import {
  TextInput,
  SwitchInput,
  Tags,
  DropdownInput,
} from "../../../common/fields";
import { Button } from "primereact/button";
import { FormContext } from "../../../common/context";
import { GlobalConstants } from "../../../../constants";

const LearningMilestoneDetailsForm = ({
  disabled = false,
  learningObjects = [],
  recordId,
}) => {
  const intl = useIntl();
  const formProvider = useContext(FormContext);
  return (
    <div className="flex flex-column gap-4">
      <Section title="identity">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="isLinear"
              component={SwitchInput}
              type="checkbox"
              label={intl.formatMessage({
                id: "is_linear",
              })}
              readOnly={disabled}
              placeholder={intl.formatMessage({
                id: "is_linear",
              })}
            />
          </div>
          {/* <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="isCertified"
              component={SwitchInput}
              type="checkbox"
              label={intl.formatMessage({
                id: "isCertified",
              })}
              readOnly={disabled}
              disabled={true}
              placeholder={intl.formatMessage({
                id: "isCertified",
              })}
            />
          </div> */}
          {/* <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="tags"
              component={Tags}
              type="text"
              label={intl.formatMessage({
                id: "tags",
              })}
              disabled={disabled}
              placeholder={intl.formatMessage({
                id: "tags",
              })}
            />
          </div> */}
        </div>
      </Section>
      {(!recordId && (
        <Section title="learning_objects">
          <FieldArray name="objects">
            {({ fields }) =>
              fields.map((name, index) => {
                const filterFields = fields?.value?.filter(
                  (_, i_index) => i_index !== index
                );
                return (
                  <div className="grid" key={index}>
                    {(index > 0 && (
                      <div className="col-12 md:col-2 lg:col-2">
                        <Field
                          name={`${name}.operator`}
                          component={DropdownInput}
                          options={GlobalConstants.LEARNING_OPERATORS.map(
                            (item) => ({
                              name: intl.formatMessage({ id: item.name }),
                              id: item.id,
                            })
                          )}
                          readOnly={index === 0}
                          label={intl.formatMessage({
                            id: "must_have",
                          })}
                          placeholder={intl.formatMessage({
                            id: "must_have",
                          })}
                          required
                          validate={Validations.composeValidators(
                            Validations.required
                          )}
                        />
                      </div>
                    )) || (
                      <div className="col-12 md:col-2 lg:col-2 flex align-items-center">
                        {intl.formatMessage({ id: "specify_rules" })}
                      </div>
                    )}
                    <div className="col-12 md:col-6 lg:col-6">
                      <div className="flex gap-2">
                        <div className="flex-grow-1">
                          <Field
                            name={`${name}.learningObject`}
                            component={DropdownInput}
                            options={learningObjects
                              .filter(
                                (item) =>
                                  !filterFields
                                    .map((item) => item.learningObject?.id)
                                    .includes(item.id)
                              )
                              .map((item) => ({
                                name: `${item.name} (${item.type})`,
                                id: item.id,
                              }))}
                            label={intl.formatMessage({
                              id: "learning_object",
                            })}
                            placeholder={intl.formatMessage({
                              id: "learning_object",
                            })}
                            showClear
                            required
                            validate={Validations.composeValidators(
                              Validations.required
                            )}
                          />
                        </div>
                        {(index && (
                          <Button
                            type="button"
                            icon="pi pi-arrow-up"
                            style={{ marginTop: "21px" }}
                            onClick={() => {
                              const current = fields.value[index];
                              const replace = fields.value[index - 1];
                              formProvider.update("objects", index, {
                                ...replace,
                                operator: current.operator,
                              });
                              formProvider.update("objects", index - 1, {
                                ...current,
                                operator: replace.operator,
                              });
                            }}
                          />
                        )) ||
                          null}
                        {(index && index !== fields.length - 1 && (
                          <Button
                            type="button"
                            icon="pi pi-arrow-down"
                            style={{ marginTop: "21px" }}
                            onClick={() => {
                              const current = fields.value[index];
                              const replace = fields.value[index + 1];
                              formProvider.update("objects", index, {
                                ...replace,
                                operator: current.operator,
                              });
                              formProvider.update("objects", index + 1, {
                                ...current,
                                operator: replace.operator,
                              });
                            }}
                          />
                        )) ||
                          null}
                      </div>
                    </div>
                    <div className="col-12 md:col-12 lg:col-2">
                      {(index === 0 && (
                        <>
                          <Button
                            type="button"
                            icon="pi pi-plus"
                            style={{ marginTop: "21px" }}
                            onClick={() =>
                              formProvider.push("objects", {
                                operator:
                                  GlobalConstants.LEARNING_OPERATORS.filter(
                                    (op) => op.default
                                  ).map((item) => ({
                                    name: intl.formatMessage({ id: item.name }),
                                    id: item.id,
                                  }))[0],
                              })
                            }
                          />
                        </>
                      )) || (
                        <div className="flex gap-2">
                          <Button
                            type="button"
                            icon="pi pi-trash"
                            style={{ marginTop: "21px" }}
                            onClick={() => fields.remove(index)}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            }
          </FieldArray>
        </Section>
      )) ||
        null}
    </div>
  );
};

export default LearningMilestoneDetailsForm;
